<template>
  <router-view class="login-view" />
</template>
